import React, { useState } from 'react';
import api from '../api'; // Uses the dynamic API file we just made
import { useNavigation } from '../contexts/NavigationContext';
import { useModal } from '../contexts/ModalContext';
import { FaLock, FaArrowLeft } from 'react-icons/fa';

const ResetPasswordPage = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    
    const { alert } = useModal();
    const { navigateTo } = useNavigation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmNewPassword) {
            setError('New passwords do not match.');
            return;
        }
        if (newPassword.length < 6) {
            setError('New password must be at least 6 characters long.');
            return;
        }

        setLoading(true);

        try {
            // Updated route to match the new server logic
            await api.put('/auth/reset-password', {
                currentPassword,
                newPassword
            });

            alert('Your password has been successfully updated.', 'Success');
            setCurrentPassword('');
            setNewPassword('');
            setConfirmNewPassword('');
            
            setTimeout(() => navigateTo('profile'), 1500);

        } catch (err) {
            console.error('Password reset error:', err);
            const errorMessage = err.response?.data?.message || 'Failed to update password.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-md">
                <button 
                    onClick={() => navigateTo('profile')}
                    className="mb-6 text-gray-500 hover:text-blue-600 flex items-center gap-2 text-sm font-bold"
                >
                    <FaArrowLeft /> Back to Profile
                </button>

                <div className="text-center mb-6">
                    <div className="bg-purple-100 text-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FaLock className="text-2xl" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800">Reset Password</h2>
                </div>

                {error && (
                    <div className="mb-4 p-3 bg-red-100 text-red-700 border-l-4 border-red-500 text-sm rounded">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-1">Current Password</label>
                        <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none transition"/>
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-1">New Password</label>
                        <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none transition"/>
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-1">Confirm New Password</label>
                        <input type="password" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none transition"/>
                    </div>

                    <button type="submit" disabled={loading} className={`w-full py-3 px-4 rounded-lg text-white font-bold shadow-md transition-all ${loading ? 'bg-purple-300 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700 hover:-translate-y-0.5'}`}>
                        {loading ? 'Updating...' : 'Update Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPasswordPage;